import type {
	DirtyFields,
	FieldConfig,
	StatusFieldProps,
	ClassificationFieldProps,
} from '@atlassian/jira-issue-create-common-types/src/common/types/index.tsx';
import type {
	ClassificationLevelField,
	CreateFormProps,
	FormData,
	StatusField,
} from '../../common/types.tsx';

export const transformFieldConfigAndDirtyFieldsCurrentSession = <T extends CreateFormProps>(
	formData: FormData,
	formDataDefaultValues: FormData | undefined,
	createFormProps: T,
): Pick<CreateFormProps, 'dirtyFieldsCurrentSession' | 'fieldConfig'> => {
	const { fieldConfig = {}, dirtyFieldsCurrentSession } = createFormProps;
	const newFieldConfig: FieldConfig = { ...fieldConfig };

	const newDirtyFieldsCurrentSession: DirtyFields = {
		...(dirtyFieldsCurrentSession?.current || {}),
	};

	if (formDataDefaultValues) {
		// adding all default values that don't already exist to the field config - defaultValueDontTransform false
		Object.keys(formDataDefaultValues).forEach((key) => {
			// TODO what do if fieldConfig doesn't have the key? eg schema change
			if (newFieldConfig[key]) {
				newFieldConfig[key] = {
					...newFieldConfig[key],
					defaultValue: formDataDefaultValues[key],
					defaultValueDontTransform: false,
				};
			}
		});
	}

	if (formData) {
		// adding/overwriting all changed field values to the field config - defaultValueDontTransform true
		Object.keys(formData).forEach((key) => {
			// TODO what do if fieldConfig doesn't have the key? eg schema change
			if (newFieldConfig[key]) {
				newFieldConfig[key] = {
					...newFieldConfig[key],
					defaultValue: formData[key],
					defaultValueDontTransform: true,
				};
				newDirtyFieldsCurrentSession[key] = true;
			}
		});
	}

	dirtyFieldsCurrentSession.current = newDirtyFieldsCurrentSession;

	return {
		fieldConfig: newFieldConfig,
		dirtyFieldsCurrentSession,
	};
};

export const transformStatusFieldProps = (
	statusField?: StatusField,
	statusFieldProps?: StatusFieldProps,
): StatusFieldProps | undefined => {
	if (statusField?.selectedTransition) {
		const newStatusFieldProps: StatusFieldProps = { ...statusFieldProps };

		newStatusFieldProps.initialTransition = statusField.selectedTransition;

		return newStatusFieldProps;
	}
	return statusFieldProps;
};

export const transformClassificationLevelFieldProps = (
	classificationLevelField?: ClassificationLevelField,
	classificationFieldProps?: ClassificationFieldProps,
): ClassificationFieldProps | undefined => {
	if (classificationLevelField?.selectedClassification) {
		const newClassificationFieldProps: ClassificationFieldProps = {
			...classificationFieldProps,
		};

		newClassificationFieldProps.initialClassification =
			classificationLevelField.selectedClassification;

		return newClassificationFieldProps;
	}
	return classificationFieldProps;
};
